import React, { useState } from 'react';
import { LogIn, Shield } from 'lucide-react';
import { Input } from '../ui/input';

export default function AdminLogin({ onLogin }) {
  const [u, setU] = useState('');
  const [p, setP] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await onLogin(u, p);
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-[radial-gradient(ellipse_at_top,#1a1a0e_0%,#0a0a0a_60%)]">
      <div className="w-full max-w-md rounded-2xl border border-zinc-800 bg-zinc-950/80 backdrop-blur p-6 md:p-8 shadow-2xl">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-11 h-11 rounded-full bg-[color:var(--gold)]/15 border border-[color:var(--gold)]/30 flex items-center justify-center text-[color:var(--gold)]">
            <Shield size={22} />
          </div>
          <div>
            <div className="text-zinc-100 font-bold text-lg">Admin Panel</div>
            <div className="text-zinc-500 text-xs">Manage every line of your website</div>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-sm font-semibold text-zinc-300 mb-1.5 block">Username</label>
            <Input value={u} onChange={(e) => setU(e.target.value)} className="h-11 bg-zinc-900 border-zinc-800 text-zinc-100" autoFocus data-testid="admin-username-input" />
          </div>
          <div>
            <label className="text-sm font-semibold text-zinc-300 mb-1.5 block">Password</label>
            <Input type="password" value={p} onChange={(e) => setP(e.target.value)} className="h-11 bg-zinc-900 border-zinc-800 text-zinc-100" data-testid="admin-password-input" />
          </div>
          <button type="submit" disabled={loading} className="w-full h-12 rounded-md bg-[color:var(--gold)] hover:brightness-110 disabled:opacity-60 text-black font-bold flex items-center justify-center gap-2" data-testid="admin-login-submit-btn">
            <LogIn size={16} /> {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
